import React, { useEffect, useState } from "react";
import TopNav from "../layouts/TopNav";
import "../Styles/invoiceTable.css";
import { toast } from "react-toastify";
import { BsSearch } from "react-icons/bs";
import TablePagination from "@mui/material/TablePagination";
import { useNavigate } from "react-router-dom";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

type Invoice = {
  name: string;
  _id: string;
  user: any;
  details: string;
  type: string;
  action: any;
  activity: string;
  createdAt: string;
};
const ActivityLogs = () => {
  const navigate = useNavigate();
  const [reLogin, setReLogin] = useState(false);
  const token = window.localStorage.getItem("token");
  const [getInvoice, setgetInvoice] = useState<Invoice[]>([]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const filterLogsByDate = (log: Invoice[]) => {
    return log.filter((req) => {
      const reqDate = new Date(req.createdAt);
      const startDate = fromDate ? new Date(fromDate) : null;
      const endDate = toDate ? new Date(toDate) : null;

      if (startDate && endDate) {
        return reqDate >= startDate && reqDate <= endDate;
      } else if (startDate) {
        return reqDate >= startDate;
      } else if (endDate) {
        return reqDate <= endDate;
      } else {
        return true; // No date range selected, so don't filter
      }
    });
  };

  function queryCustomer() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/business/logs", {
        headers: headers,
      })
      .then((res) => {
        setgetInvoice(res.data.data.logs);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
           
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error.response.data.message);
      });
  }

  useEffect(() => {
    queryCustomer();
  }, []);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="board">
      <TopNav title="Activity Log" />
      {reLogin ? <ReLoginModal /> : null}
      <div className="method" style={{ marginTop: "1em" }}>
        <div className="apInput">
          <input
            type="text"
            value={searchQuery}
            placeholder="search by name"
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <BsSearch className="apIcon" />
        </div>
        Filter By:
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
        {/* "To" date input */}
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
      </div>

      <div className="invoiceTable">
        <table className="inTable">
          <tr className="heTble tabHead">
            <th className="sn">S/N</th>
            <th>name</th>
            <th>Role</th>
            <th>email</th>
            <th>Activity</th>
            <th>details</th>
            <th>action</th>
            {/* <th>type</th> */}
            <th>Date</th>
          </tr>

          {filterLogsByDate(getInvoice)
            ?.filter((invoice) =>
              invoice?.user?.fullName
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
            )
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((invoice, inx) => {
              const createdAtDate = new Date(invoice?.createdAt);
              // Format date and time
              const formattedDate = createdAtDate.toLocaleString();
              return (
                <tr key={inx} className="taData">
                  <td className="sn">{inx + 1}</td>
                  <td>{invoice?.user?.fullName}</td>
                  <td>{invoice?.user.role}</td>
                  <td>{invoice?.user.email}</td>
                  <td>{invoice?.activity}</td>
                  <td>{invoice?.details}</td>
                  <td>{invoice?.action}</td>
                  {/* <td>{invoice?.type}</td> */}
                  <td>{formattedDate}</td>
                </tr>
              );
            })}
        </table>
      </div>

      <TablePagination
        rowsPerPageOptions={[15, 25, 50]}
        component="div"
        count={getInvoice.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default ActivityLogs;
